module.exports = __webpack_public_path__ + "img/2c.68f33343.svg";